import { useTask } from 'app/agriculture/queries/tasks/useTask';
import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { RichTextDisplay } from 'app/agriculture/components/RichTextDisplay/RichTextDisplay';
import { Actions } from 'app/agriculture/components/Actions/Actions';
import { TaskIcon } from 'app/agriculture/icons';
import { TaskHeader } from 'app/agriculture/routes/Tasks/components/TaskHeader/TaskHeader';
import { TaskStats } from 'app/agriculture/routes/Tasks/components/TaskStats/TaskStats';
import { useNavigate } from 'react-router-dom';
import { useRouteActions } from 'app/agriculture/router/useRouteActions';
import { ShowOnMapButton } from 'app/agriculture/components/ContentBox/components/ShowOnMapButton';
import { convertMapLocationToPosition } from 'app/agriculture/components/utils/convertMapLocationToPosition';

interface TaskDetailsComponentProps {
    taskId: string;
}

export function TaskDetailsComponent({ taskId }: TaskDetailsComponentProps) {
    const { description, location } = useTask({ taskId });
    const navigate = useNavigate();
    const routeActions = useRouteActions();

    return (
        <ContentBox
            title="Task Details"
            Icon={TaskIcon}
            showOnMapButton={<ShowOnMapButton position={convertMapLocationToPosition(location)} />}
            className="TaskDetails"
            variant="lg"
        >
            <ContentBox.Section scrollable>
                <ContentBox.Section className="TaskDetails__content">
                    <TaskHeader taskId={taskId} />
                    {description != null && <RichTextDisplay text={description} />}
                </ContentBox.Section>
                <ContentBox.Section className="TaskDetails__stats">
                    <TaskStats taskId={taskId} showCategory />
                </ContentBox.Section>
                <Actions
                    sticky
                    primaryAction={{
                        text: 'Edit',
                        startIcon: 'edit',
                        onClick: () => {
                            navigate('edit');
                        },
                    }}
                    backAction={{
                        text: 'All Tasks',
                        onClick: () => {
                            routeActions.openList('Task');
                        },
                    }}
                />
            </ContentBox.Section>
        </ContentBox>
    );
}
